// PasswordResetRequest.js
import React, { useState } from 'react';
import axiosInstance from '../../axiosConfig';
import Notification from '../notification/Notification';
import '../../styles/Auth.css';

const PasswordResetRequest = () => {
    const [email, setEmail] = useState('');
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleRequest = async (e) => {
        e.preventDefault();

        if (!validateEmail(email)) {
            setNotification({ message: 'Please enter a valid email address.', isError: true });
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post('/api/auth/request-password-reset', { email });

            // Use the message from the backend response
            setNotification({ message: response.data.message, isError: false });

        } catch (error) {
            // Check if the error response has a message from the backend
            const errorMessage = error.response?.data?.error || 'Error sending reset link. Try again later.';

            setNotification({ message: errorMessage, isError: true });

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="password-reset">
            <h2>Reset Password</h2>
            <form onSubmit={handleRequest} className='password-reset-form'>
                <input
                    className='password-reset-email'
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                />
                <button type="submit" disabled={loading} className="auth-button">
                    {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
                {notification && (
                    <Notification
                        message={notification.message}
                        isError={notification.isError}
                        onClose={() => setNotification(null)}
                    />
                )}
            </form>
        </div>
    );
};

export default PasswordResetRequest;
